import * as React from "react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { wrap } from "framer-motion";
import './index2';
import './ExpandedImage.css'


const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

export const ExpandedImage = ({ imageUrl, relatedImages, onClose }) => {
    const [[page, direction], setPage] = useState([0, 0]);
    //const imageIndex = wrap(0, relatedImages.length, page);
    const imageIndex = relatedImages ? wrap(0, relatedImages.length, page) : 0;
    
    const paginate = (newDirection) => {
      if (relatedImages && relatedImages.length > 1) {
    setPage([page + newDirection, newDirection]);
      }
  };

  return (
    <AnimatePresence initial={false} custom={direction}>
    <div className="expanded-image-container">
      
        {relatedImages && relatedImages.length > 0 ? (
          <motion.img
              key={page}
              src={relatedImages[imageIndex]}
              custom={direction}
              variants={{
                enter: (direction) => {
                  return {
                    x: direction > 0 ? 1000 : -1000,
                    opacity: 0
                  };
                },
              center: {
                  zIndex: 1,
                  x: 0,
                  opacity: 1
                },
              exit: (direction) => {
                return {
                  zIndex: 0,
                  x: direction < 0 ? 1000 : -1000,
                  opacity: 0
              };
              }
            }}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 }
          }}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={1}
          onDragEnd={(e, { offset, velocity }) => {
            const swipe = swipePower(offset.x, velocity.x);

            if (swipe < -swipeConfidenceThreshold) {
              paginate(1);
            } else if (swipe > swipeConfidenceThreshold) {
              paginate(-1);
            }
          }}
        />
        ) : (
            <img src={imageUrl} alt="Expanded Image" />
          )}

     
      {relatedImages && relatedImages.length > 1 && (
        <>
          <div className="next-button2" onClick={() => paginate(1)}>
            {"‣"}
          </div>
          <div className="prev-button2" onClick={() => paginate(-1)}>
            {"‣"}
          </div>
        </>
      )}
      <button className="close-button2" onClick={onClose}>Close</button>
    </div>
    </AnimatePresence>
  );
};

export default ExpandedImage;

